import { CANNOT_CAPTURE_MESSAGE } from '@/lib/access/access-model';

/** OPERATOR_ACCESS.md section 5: shown at every capture entry point in
 *  place of the shutter when the caller lacks `captureInField`. */
export function NoCaptureAccess() {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-card border border-border p-6 text-center">
      <p className="text-sm text-muted">{CANNOT_CAPTURE_MESSAGE}</p>
    </div>
  );
}
